import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";

function ClientList({
  onChangeList,
  onInitial,
  axValue,
  axLabel,
  showLabel = true,
  refreshKey = 0,
}) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const hasInitialized = useRef(false);
  // Ref so the effect can read the latest onInitial/onChangeList without them being deps
  const onInitialRef = useRef(onInitial);
  const onChangeListRef = useRef(onChangeList);
  useEffect(() => {
    onInitialRef.current = onInitial;
  }, [onInitial]);
  useEffect(() => {
    onChangeListRef.current = onChangeList;
  }, [onChangeList]);

  useEffect(() => {
    const fetchClientList = async () => {
      try {
        const response = await axios.get(
          "https://eps.elkomprintama.com/get/api/clients",
        );
        const clientData = response.data.result;

        const clientOptions = clientData.map((client) => ({
          value: client.cust_id,
          label: client.nme,
        }));

        setClients(clientOptions);

        if (!hasInitialized.current && clientOptions.length > 0) {
          const initialClient = {
            value: axValue || clientOptions[0].value,
            label: axLabel || clientOptions[0].label,
          };
          setSelectedClient(initialClient);
          if (typeof onInitialRef.current === "function") {
            onInitialRef.current(initialClient.value);
          }
          hasInitialized.current = true;
        }

        // After a new customer is added, auto-select the newest entry
        if (refreshKey > 0) {
          const last = clientOptions[clientOptions.length - 1];
          if (last) {
            setSelectedClient(last);
            onChangeListRef.current(last.value);
          }
        }
      } catch (error) {
        console.error("Error fetching clients data:", error);
      }
    };

    fetchClientList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [axValue, axLabel, refreshKey]); // onInitial/onChangeList intentionally excluded — accessed via ref

  const handleClientChange = (selectedOption) => {
    setSelectedClient(selectedOption);
    onChangeList(selectedOption.value);
  };

  return (
    <>
      {showLabel && (
        <label
          htmlFor="client_list"
          className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2"
        >
          Customer
        </label>
      )}
      <div className="control w-full">
        <Select
          options={clients}
          className="block w-full border border-green-400 text-gray-700 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          id="client_list"
          name="client_list"
          onChange={handleClientChange}
          value={selectedClient}
          styles={{
            control: (provided, state) => ({
              ...provided,
              border: state.isFocused
                ? "2px solid #4CAF50"
                : "1px solid #ced4da",
              boxShadow: "none",
            }),
          }}
        />
      </div>
    </>
  );
}

export default ClientList;
